import React from 'react';

const ArrowUp = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M12.2929 7.70711C12.6834 8.09763 13.3166 8.09763 13.7071 7.70711C14.0976 7.31658 14.0976 6.68342 13.7071 6.29289L7.70711 0.292894C7.31658 -0.0976302 6.68342 -0.0976302 6.29289 0.292894L0.292893 6.29289C-0.0976306 6.68342 -0.0976305 7.31658 0.292893 7.70711C0.683417 8.09763 1.31658 8.09763 1.70711 7.70711L7 2.41421L12.2929 7.70711Z"
      fill="#747E8A"
    />
  </svg>
);

export default ArrowUp;
